export default "__VITE_ASSET__N23_GFp2__"